export default __webpack_public_path__ + "static/media/icon-s-loop.800be9ad.svg";